import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getAppointments,
  deleteAppointment,
  updateAppointmentStatus,
  updateAppointment,
  getAppointmentsStatus,
  completeAppointment, // Add this import
  createAppointment,
} from "@/services/api/appointments"

export const useFetchAppointments = (
  offset,
  limit,
  search,
  appointment_status,
  start_date,
  end_date,
  patient_id
) => {
  return useQuery({
    queryKey: [
      "appointments",
      offset,
      limit,
      search,
      appointment_status,
      start_date,
      end_date,
      patient_id,
    ],
    queryFn: async () => {
      const res = await getAppointments({
        offset,
        limit,
        search,
        appointment_status,
        start_date,
        end_date,
        patient_id,
      })
      return res.data
    },
    select: (response) => ({
      appointments: response.data.appointments,
      pagination: {
        total: response.data.total,
        totalPages: Math.ceil(response.data.total / limit),
      },
    }),
    // staleTime: 5 * 60 * 1000,
  })
}

export const useDeleteAppointment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id) => deleteAppointment(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] })
    },
  })
}

export const useUpdateAppointmentStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, status, doctor_id }) =>
      updateAppointmentStatus(id, status, doctor_id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] })
    },
  })
}

export const useUpdateAppointment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => updateAppointment(data.id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] })
    },
  })
}

export const useCompleteAppointment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, formData }) => completeAppointment(id, formData), // Fix: destructure formData
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] })
    },
  })
}

export const useCreateAppointment = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => createAppointment(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["appointments"] })
    },
  })
}

export function useAppointmentStatus(patientId) {
  return useQuery({
    queryKey: ["appointment-status", patientId],
    queryFn: () => getAppointmentsStatus(patientId),
    enabled: !!patientId,
  })
}
